import React, { useCallback } from 'react';

import { GoalId } from '../types';
import { GoalOption } from '../useGoalSelectOptions';
import {
  SelectSingleBase,
  Props as SelectSingleBaseProps,
  RenderOptionParams,
} from '../../../../components/Selects/SelectSingleBase';
import { GoalInlineLabels } from './GoalInlineLabels';

export type Props = {
  value: GoalId | null;
  options: GoalOption[];
  onChange: (value: GoalId | null) => void;
} & Pick<
  SelectSingleBaseProps<GoalOption>,
  'placeholder' | 'noOptionsMessage' | 'className' | 'isDisabled' | 'heightMode'
>;

export const SelectSingleGoal: React.FC<React.PropsWithChildren<Props>> = ({
  value,
  onChange,
  options,
  ...rest
}) => {
  const handleOnChange = useCallback(
    (value: string | null) => {
      if (value === null) {
        onChange(null);
      } else {
        const option = options.find((x) => x.value === value);
        onChange(option ? { id: option.value, type: option.goalType } : null);
      }
    },
    [onChange, options],
  );

  const renderOption = useCallback(
    ({ option }: RenderOptionParams<GoalOption>) => {
      const goalOption = option as GoalOption;

      return (
        <div className="d-flex align-items-center gap-2">
          <span className="fs-5 text-truncate">{goalOption.label}</span>
          <GoalInlineLabels
            goalType={goalOption.goalType}
            goalEmployee={goalOption.goalEmployee}
            goalTeam={goalOption.goalTeam}
          />
        </div>
      );
    },
    [],
  );

  return (
    <SelectSingleBase
      {...rest}
      options={options}
      value={value ? value.id : null}
      fullWidthMenu={true}
      onChange={handleOnChange}
      renderOption={renderOption}
    />
  );
};
